<nav class="navbar navbar-expand-md navbar-dark skin-blue fixed-top">
  <div class="container mr-rt-0">
    <a class="navbar-brand text-white" href="#">
      <img src="../../assets/img/iFIX_Website_Logo.jpg" height="40" width="40">
    </a>
    <a class="nav-toggle" (click)="sidenav.toggle()"
    >
      <div class="ham"></div>
      <div class="ham"></div>
      <div class="ham"></div>
    </a>
    <ul class="navbar-nav ml-auto">

<!--      <div class="drop-btn btn-skin-blue" (click)="langCollapse()"-->
<!--           [attr.aria-expanded]="!isLanCollapsed" aria-controls="lanDetails">-->
<!--        Language-->
<!--        <i class="fa fa-angle-down" aria-hidden="true"></i>-->
<!--      </div>-->
      <div class="drop-btn btn-skin-blue" (click)="userCollapse()"
           [attr.aria-expanded]="!isUserCollapsed" aria-controls="userDetails">
        <i class="fa fa-user fa-fw"></i>
        {{userName}}
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </div>

      <div id="userDetails" [ngbCollapse]="isUserCollapsed">
        <div class="card userCard">
          <div class="card-header">
            <div class="user-header bg-light-blue"><img src="../../assets/img/avatar3.png" class="img-circle"
                                                        alt="User Image">
              <p>
                {{userName}} - OrgAdmin
                <small></small>
              </p>
            </div>
          </div>
          <!--<div class="card-body">-->
            <!--<a href="#" class="card-link">Tickets</a>-->
            <!--<a href="#" class="card-link">Team</a>-->
          <!--</div>-->
          <div class="card-footer">

            <div class="left">
              <a href="#" class="btn btn-light btn-flat">Profile</a>
            </div>
            <div class="right">
              <a href="#" class="btn btn-light btn-flat" (click)="signOut()">Sign out</a>
            </div>
          </div>
        </div>
      </div>
      <div id="lanDetails" [ngbCollapse]="isLanCollapsed">
        <div class="card lanCard">
          <ul class="list-group list-group-flush">
            <li class="list-group-item list-grp-pad">Kannada</li>
            <li class="list-group-item list-grp-pad">English</li>
          </ul>
        </div>
      </div>


    </ul>
    <!--</div>-->
  </div>
</nav>
<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'push' : 'side'" class="nav-content" [(opened)]="opened">
    <div class="user-panel">
      <div class="pull-left image">

        <img src="../../assets/img/avatar3.png" class="img-circle" alt="User Image">
      </div>
      <div class="pull-left info">
        <p>
          Hello,{{userName}}
        </p>

        <i class="fa fa-circle text-success"></i> Online
      </div>
    </div>
    <!--<mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4">-->
    <!--<mat-tab label="Platform Config">-->
    <!--<div class="navigation">-->
    <!--<ul>-->
    <!--<li *ngFor="let nav of  navbars.admin" [ngClass]="{'has-sub':nav.sub}">-->
    <!--<a (click)="changeRouting(nav.path)">{{nav.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!nav.sub}">-->
    <!--<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">-->
    <!--<a (click)="changeRouting(child.path)">{{child.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!child.sub}">-->
    <!--<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">-->
    <!--<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!subChild.sub}">-->
    <!--<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">-->
    <!--<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</li>-->
    <!--</ul>-->

    <!--</li>-->
    <!--</ul>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</mat-tab>-->
    <!--<mat-tab label="Client Config">-->
    <!--<div class="navigation">-->
    <!--<ul>-->
    <!--<li *ngFor="let nav of  navbars.client" [ngClass]="{'has-sub':nav.sub}">-->
    <!--<a (click)="changeRouting(nav.path)">{{nav.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!nav.sub}">-->
    <!--<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">-->
    <!--<a (click)="changeRouting(child.path)">{{child.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!child.sub}">-->
    <!--<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">-->
    <!--<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>-->
    <!--<ul [ngClass]="{'no-border':!subChild.sub}">-->
    <!--<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">-->
    <!--<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</li>-->
    <!--</ul>-->

    <!--</li>-->
    <!--</ul>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</mat-tab>-->
    <!--</mat-tab-group>-->
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Platform Config
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-material-multilevel-menu  [items]='navbarAdmin' (selectedItem)="changeRouting($event.path)">
        </ng-material-multilevel-menu>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Client Config
          </mat-panel-title>

        </mat-expansion-panel-header>

        <ng-material-multilevel-menu  [items]='navbarClient' (selectedItem)="changeRouting($event.path)">
        </ng-material-multilevel-menu>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-sidenav>

  <mat-sidenav-content opened=true>
    <router-outlet></router-outlet>
    <footer class="footer row">
      <!--<div class="container footer-text">-->
        <!--<b>Copyright {{copyYear}} <span class="blue">i</span><span class="red">FIX</span> -Version 3.0.0</b>-->
      <!--</div>-->
      <div class="footer-text-left col-sm-5">
        <b>Copyright {{copyYear}} <span class="blue">i</span><span class="red">FIX</span> -Version 3.0.0</b>
      </div>
      <div class="footer-text-right col-sm-7">
        <b><span>*Browser Support: Please use Google chrome for better user experience</span></b>
      </div>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<!--<div class="side-bar" id="sideNavBar" [ngbCollapse]="isCollapsed">-->
<!--<div class="user-panel">-->
<!--<div class="pull-left image">-->

<!--<img src="../../assets/img/avatar3.png" class="img-circle" alt="User Image">-->
<!--</div>-->
<!--<div class="pull-left info">-->
<!--<p >-->
<!--Hello-->
<!--, mantechadmin-->
<!--</p>-->

<!--<a href="#"><i class="fa fa-circle text-success"></i> Online</a>-->
<!--</div>-->
<!--</div>-->
<!--<mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4">-->
<!--<mat-tab label="Admin Config">-->
<!--<div class="navigation">-->
<!--<ul>-->
<!--<li *ngFor="let nav of  navbars" [ngClass]="{'has-sub':nav.sub}">-->
<!--<a (click)="changeRouting(nav.path)">{{nav.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!nav.sub}">-->
<!--<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">-->
<!--<a (click)="changeRouting(child.path)">{{child.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!child.sub}">-->
<!--<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">-->
<!--<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!subChild.sub}">-->
<!--<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">-->
<!--<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>-->
<!--</li>-->
<!--</ul>-->
<!--</li>-->
<!--</ul>-->

<!--</li>-->
<!--</ul>-->
<!--</li>-->
<!--</ul>-->
<!--</div>-->
<!--</mat-tab>-->
<!--<mat-tab label="Client Config"> <div class="navigation">-->
<!--<ul>-->
<!--<li *ngFor="let nav of  navbars" [ngClass]="{'has-sub':nav.sub}">-->
<!--<a (click)="changeRouting(nav.path)">{{nav.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!nav.sub}">-->
<!--<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">-->
<!--<a (click)="changeRouting(child.path)">{{child.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!child.sub}">-->
<!--<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">-->
<!--<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>-->
<!--<ul [ngClass]="{'no-border':!subChild.sub}">-->
<!--<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">-->
<!--<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>-->
<!--</li>-->
<!--</ul>-->
<!--</li>-->
<!--</ul>-->

<!--</li>-->
<!--</ul>-->
<!--</li>-->
<!--</ul>-->
<!--</div> </mat-tab>-->
<!--</mat-tab-group>-->
<!--&lt;!&ndash;<ngb-tabset [justify]="currentJustify" class="font-13">&ndash;&gt;-->
<!--&lt;!&ndash;<ngb-tab title="Admin Config">&ndash;&gt;-->
<!--&lt;!&ndash;<ng-template ngbTabContent>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="navigation">&ndash;&gt;-->
<!--&lt;!&ndash;<ul >&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let nav of  navbars" [ngClass]="{'has-sub':nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(nav.path)">{{nav.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(child.path)">{{child.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->

<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;</ngb-tab>&ndash;&gt;-->
<!--&lt;!&ndash;<ngb-tab title="Client Config">&ndash;&gt;-->
<!--&lt;!&ndash;<ng-template ngbTabContent>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="navigation">&ndash;&gt;-->
<!--&lt;!&ndash;<ul >&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let nav of  navbars" [ngClass]="{'has-sub':nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(nav.path)">{{nav.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(child.path)">{{child.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->

<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;</ngb-tab>&ndash;&gt;-->
<!--&lt;!&ndash;</ngb-tabset>&ndash;&gt;-->

<!--&lt;!&ndash;<div class="navigation">&ndash;&gt;-->
<!--&lt;!&ndash;<ul >&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let nav of  navbars" [ngClass]="{'has-sub':nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(nav.path)">{{nav.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!nav.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let child of nav.sub" [ngClass]="{'has-sub':child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(child.path)">{{child.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!child.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let subChild of child.sub" [ngClass]="{'has-sub':subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(subChild.path)">{{subChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<ul [ngClass]="{'no-border':!subChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<li *ngFor="let grandChild of subChild.sub" [ngClass]="{'has-sub':grandChild.sub}">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="changeRouting(grandChild.path)">{{grandChild.name}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->

<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</li>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"> <a href="#">Data Govern. & Compliance(DGC)</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;&lt;!&ndash;<li><a (click)="changeRouting('organisation')">Organisation Master</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a (click)="changeRouting('vendor')">Vendor Master </a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Roles</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">SupportGroup </a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"> <a href="#">Users</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">User Master</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">BPRA Matrix</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">User SupportGroup</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"><a href="#">HUL RS Master</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">RS Master Code</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"><a href="#">Best Practise</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"><a href="#">Ticket Category</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Org Group</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Levels of Categories</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Category Master</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Category Support Group</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Status</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">SLA Master</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Business Impact</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Business Urgency </a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Priority Master</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Auto Priority</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Approval Authority Matrix(AAM)</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Items</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"> <a href="#">Digital Service Exchange (DSE)</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a (click)="changeRouting('createTicket')">Create Ticket</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a (click)="changeRouting('viewTicket')">View Ticket</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li class="has-sub"> <a href="#">Service Mgmt Analytics(SMA)</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<li><a href="#">Ticket Movement</a></li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</ul>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;</ul>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->

<!--</div>-->
<!--<footer class="footer" [ngClass]="{'mr-lft-220':opened}">-->
<!--<div class="container footer-text">-->
<!--<b>Copyright 2018 <span class="blue">i</span><span class="red">FIX</span> -Version 2.4.0</b>-->
<!--</div>-->
<!--</footer>-->
<!--<router-outlet></router-outlet>-->
